export const CANONICAL_PLACES = [
  {
    id: "us-ny-niagara-newfane-14108",
    country: "United States",
    stateProvinceRegion: "New York",
    county: "Niagara County",
    city: "Newfane",
    postalCode: "14108",
    label: "Newfane, Niagara County, New York, United States",
  },
  {
    id: "us-ny-erie-buffalo-14202",
    country: "United States",
    stateProvinceRegion: "New York",
    county: "Erie County",
    city: "Buffalo",
    postalCode: "14202",
    label: "Buffalo, Erie County, New York, United States",
  },
  {
    id: "in-ka-bengaluru-urban-bengaluru-560001",
    country: "India",
    stateProvinceRegion: "Karnataka",
    county: "Bengaluru Urban",
    city: "Bengaluru",
    postalCode: "560001",
    label: "Bengaluru, Bengaluru Urban, Karnataka, India",
  },
  {
    id: "jp-tokyo-tokyo-shibuya-1500002",
    country: "Japan",
    stateProvinceRegion: "Tokyo",
    county: "Tokyo",
    city: "Shibuya",
    postalCode: "150-0002",
    label: "Shibuya, Tokyo, Japan",
  },
];

export const getCanonicalPlacesForCountry = (country) =>
  CANONICAL_PLACES.filter((place) => place.country === country);

export const getCanonicalPlaceById = (id) =>
  CANONICAL_PLACES.find((place) => place.id === id) ?? null;
